export default __webpack_public_path__ + "static/angled-1c6bd4b09bde73e4d98482a6070a0852.png";